import { bindActionCreators } from 'redux'

import ConfirmPayment from '@piconetworks/confirm-payment'

import withInjection from '@piconetworks/with-injection'

import Internal from 'common/modules/internal'
import Gift from 'common/modules/gift'
import Loader from 'common/modules/loader'
import Arbiter from 'common/modules/arbiter'
import Plan from 'common/modules/plan'
import Wizard from 'common/modules/wizard'
import Zoid from 'common/modules/zoid'

import WizardRedux, { WizardLoading, WizardError } from 'common/pkgs/WizardRedux'

const mapStateToProps = (state, props) => {
    const { router } = props
    const wizardName = props?.router?.query?.id

    const guestLoader = state.loader.guest
    const userLoader = state.loader.user
    const thisWizard = Wizard.selectors.thisWizard({ state, router })
    const isSwitchingPlans = thisWizard?.submit?.payload?.currentPlanTierId
    const userVerified = Loader.selectors.userVerified(state)
    const isGift = thisWizard?.submit?.payload?.isGift

    const popupId = thisWizard?.submit?.payload?.popupId
    const popup = Loader.selectors.popupGetPopupById(state, popupId)

    // we need to remove the directPlanOptionId from the plan object to
    // prevent reset plan being called unnecessarily

    const { directPlanOptionId, ...originalPlanObject } = state.plan

    return {
        ...props,
        gift: state.gift,
        plan: originalPlanObject,
        guestLoader,
        userLoader,
        wizard: state.wizard,
        thisWizard,
        updateLoader: Loader.creators.updateLoader,
        publisherId: Loader.selectors.publisherId(state),
        planInitialState: Plan.initialState,
        utm: Zoid.selectors.getUTM(state),
        onPurchaseSucceeded: () => {},
        WizardRedux,
        WizardLoading,
        WizardError,
        isSwitchingPlans,
        userVerified,
        utmRootUrl: process.env.MARKETING_SITE_URL,
        onBackButtonClick: () => {
            if (isGift) {
                router.replace({
                    pathname: '/gift-form',
                    query: {
                        ...(thisWizard?.id && { id: thisWizard.id }),
                    },
                }, {
                    pathname: '/gift-form',
                    query: {
                        ...(thisWizard?.id && { id: thisWizard.id }),
                    },
                })
            } else {
                router.replace({
                    pathname: '/cards',
                    query: {
                        resetWizard: true,
                        ...(thisWizard?.id && { id: thisWizard.id }),
                    },
                }, {
                    pathname: '/cards',
                    query: {
                        resetWizard: true,
                        ...(thisWizard?.id && { id: thisWizard.id }),
                    },
                })
            }
        },
        redeemUrl: `${Loader.selectors.publisherUrl(state)}?pn=redeem_gift`,
        last4: (
            !state.payment.isDefaultBeingSet
            && Loader.selectors.badgePaymentMethod(state)?.last4
        ),
        cardType: (
            !state.payment.isDefaultBeingSet
            && Loader.selectors.badgePaymentMethod(state)?.cardType
        ),
        paymentBadgeLink: wizardName && {
            href: {
                pathname: '/cards',
                query: {
                    ...(wizardName && { id: wizardName }),
                },
            },
            as: {
                pathname: '/cards',
                query: {
                    ...(wizardName && { id: wizardName }),
                },
            },
        },
        onUnfoundPlanOption: () => {
            router.replace({
                pathname: '/select-plan',
                query: {
                    ...(thisWizard?.id && { id: thisWizard.id }),
                },
            }, {
                pathname: '/select-plan',
                query: {
                    ...(thisWizard?.id && { id: thisWizard.id }),
                },
            })
        },
        isGiftSub: Loader.selectors.currentSubscriptionId(state) === 'GIFT',
        currentPurchaseActive: Loader.selectors.currentPurchaseActive(state),
        giftId: state.gift.giftId,
        queryOverride: {
            utmCampaign: state?.zoid?.tag,
            utmSource: Loader.selectors.publisherName(state),
            utmMedium: process.env.HOSTNAME,
            utmContent: 'ConfirmPayment',
            rootUrl: process.env.MARKETING_SITE_URL,
        },
        popup,
    }
}

const mapDispatchToProps = (dispatch) => ({
    ...bindActionCreators({
        planReset: Plan.creators.reset,
        planInitialize: Plan.creators.initialize,
        createGift: Gift.creators.createGift,
    }, dispatch),
    purchasePlan: (payload) => Internal.helpers.invalidateLoader({
        payload,
        action: Plan.creators.purchasePlan,
        dispatch,
    }),
    purchasePlanGroup: (payload) => Internal.helpers.invalidateLoader({
        payload,
        action: Plan.creators.purchasePlanGroup,
        dispatch,
    }),
    purchaseSwitch: (payload) => Internal.helpers.invalidateLoader({
        payload,
        action: Plan.creators.purchaseSwitch,
        dispatch,
    }),
    sendExternalLink: (payload) => dispatch(Internal.creators.sendMessage({
        payload: {
            target: 'pico_arbiter',
            ...Arbiter.creators.sendExternalLink({
                payload,
            }),
        },
    })),
    convertGift: (payload) => Internal.helpers.invalidateLoader({
        payload,
        action: Gift.creators.convertGift,
        dispatch,
    }),
    getGift: (payload) => Internal.helpers.invalidateLoader({
        payload,
        action: Gift.creators.getGift,
        dispatch,
    }),
})

const InjectedConfirmPayment = withInjection(ConfirmPayment, {
    mapStateToProps,
    mapDispatchToProps,
})

export default InjectedConfirmPayment
